import { useEffect, useState } from 'react';

const ADOBE_SDK_URL = 'https://documentservices.adobe.com/view-sdk/viewer.js';

export function useAdobeDCView() {
  const [adobeDC, setAdobeDC] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if ((window as any).AdobeDC) {
      setAdobeDC((window as any).AdobeDC);
      setIsLoading(false);
      return;
    }

    const existingScript = document.querySelector(`script[src="${ADOBE_SDK_URL}"]`);
    if (existingScript) {
      let attempts = 0;
      const maxAttempts = 50;
      const pollInterval = setInterval(() => {
        attempts++;
        if ((window as any).AdobeDC) {
          clearInterval(pollInterval);
          setAdobeDC((window as any).AdobeDC);
          setIsLoading(false);
        } else if (attempts >= maxAttempts) {
          clearInterval(pollInterval);
          setError(new Error('Timeout waiting for Adobe DC View SDK'));
          setIsLoading(false);
        }
      }, 100);

      return () => clearInterval(pollInterval);
    }

    const script = document.createElement('script');
    script.src = ADOBE_SDK_URL;
    script.async = true;

    script.onload = () => {
      let attempts = 0;
      const maxAttempts = 50;
      const pollInterval = setInterval(() => {
        attempts++;
        if ((window as any).AdobeDC) {
          clearInterval(pollInterval);
          setAdobeDC((window as any).AdobeDC);
          setIsLoading(false);
        } else if (attempts >= maxAttempts) {
          clearInterval(pollInterval);
          setError(new Error('Adobe DC View SDK loaded but not initialized'));
          setIsLoading(false);
        }
      }, 100);
    };

    script.onerror = () => {
      const err = new Error('Failed to load Adobe DC View SDK');
      setError(err);
      setIsLoading(false);
    };

    document.head.appendChild(script);
  }, []);

  return { adobeDC, isLoading, error };
}
